import { useEffect, useRef } from 'react';

// INFO: inspired by https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useBrowserInterceptor = (intercept: boolean, handler?: (params?: BeforeUnloadEvent) => any) => {
  const unloadEventListenerRef = useRef<(e: BeforeUnloadEvent) => string>(null);

  useEffect(() => {
    unloadEventListenerRef.current = event => {
      const returnValue = handler?.(event);

      if (typeof returnValue === 'string') {
        return (event.returnValue = returnValue);
      }

      if (event.defaultPrevented) {
        return (event.returnValue = '');
      }
    };
  }, [handler]);

  useEffect(() => {
    const eventListener = (event: BeforeUnloadEvent) => unloadEventListenerRef.current(event);
    if (intercept) {
      window.addEventListener('beforeunload', eventListener);
    }
    return () => {
      window.removeEventListener('beforeunload', eventListener);
    };
  });
};
